import { Component } from 'react';
import console from 'console';

export default class BasicComponent extends Component {
  constructor(props) {
    super(props);
    this.initLogger();
  }
  initLogger() {
    const levels = ['log', 'dir', 'error', 'count', 'info'];
    let self = this;
    let debugMode = this.props.debugMode;
    levels.forEach(function (level) {
      if (debugMode) {
        self[level] = function() {
          const args = ['[' + (self.constructor.name || 'undefined').toLowerCase() + '-component]'].concat(Array.prototype.slice.call(arguments));
          console[level].apply(console, args);
        };
      } else {
        self[level] = function() {};
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/basic.js